import { render, staticRenderFns } from "./StartChat.vue?vue&type=template&id=f57c4daa&"
import script from "./StartChat.vue?vue&type=script&lang=js&"
export * from "./StartChat.vue?vue&type=script&lang=js&"
import style0 from "./StartChat.vue?vue&type=style&index=0&id=f57c4daa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports